import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, Trash2 } from 'lucide-react';

const AdminSettingsTab = ({
  scholarshipTypes,
  newScholarshipType,
  setNewScholarshipType,
  addScholarshipType,
  removeScholarshipType
}) => {
  return (
    <div className="space-y-6">
      {/* Scholarship Types Settings */}
      <div className="bg-white rounded-sm border border-slate-200 p-6">
        <h3 className="font-heading text-lg font-semibold text-slate-900 mb-4">Scholarship Types</h3>
        <p className="text-sm text-slate-500 mb-4">
          Configure the types of scholarships that can be created. These will appear in the dropdown when creating or editing scholarships.
        </p>
        
        {/* Current Types */}
        <div className="space-y-3 mb-6">
          <h4 className="text-sm font-medium text-slate-700">Current Types</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {scholarshipTypes.map((type) => (
              <div key={type.id} className="flex items-center justify-between bg-slate-50 border border-slate-200 rounded-sm px-3 py-2">
                <div>
                  <p className="font-medium text-sm text-slate-900">{type.name}</p>
                  <p className="text-xs text-slate-500 font-mono">{type.id}</p>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => removeScholarshipType(type.id)}
                  className="text-red-500 hover:text-red-700 hover:bg-red-50 h-8 w-8 p-0"
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            ))}
          </div>
        </div>
        
        {/* Add New Type */}
        <div className="bg-slate-50 border border-slate-200 rounded-sm p-4">
          <h4 className="text-sm font-medium text-slate-700 mb-3">Add New Type</h4>
          <div className="flex flex-col sm:flex-row gap-3">
            <Input
              placeholder="Display Name (e.g. Master's Degree)"
              value={newScholarshipType.name}
              onChange={(e) => {
                const name = e.target.value;
                // Auto-generate ID if it's empty or matches the previous auto-generated ID
                const currentAutoId = newScholarshipType.name.toLowerCase().replace(/\s+/g, '_');
                if (!newScholarshipType.id || newScholarshipType.id === currentAutoId) {
                  setNewScholarshipType({ 
                    name, 
                    id: name.toLowerCase().replace(/\s+/g, '_') 
                  });
                } else {
                  setNewScholarshipType({ ...newScholarshipType, name });
                }
              }}
              className="flex-1 rounded-sm"
            />
            <Input
              placeholder="System ID (e.g. masters_degree)"
              value={newScholarshipType.id}
              onChange={(e) => setNewScholarshipType({ ...newScholarshipType, id: e.target.value })}
              className="flex-1 rounded-sm"
            />
            <Button
              onClick={addScholarshipType}
              className="bg-greek-blue hover:bg-greek-blue-dark rounded-sm"
            >
              <Plus className="w-4 h-4 mr-2" />
              Add Type
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettingsTab;